import { Component, OnInit, ViewChild, ViewContainerRef, ComponentFactoryResolver, Type, ComponentRef } from '@angular/core';
import { WidgetComponent } from '../widget/widget.component';
import { TableColumn } from '../table.column';
import { TableComponent } from '../table.component';
import { TableElement } from '../table.element';
import { TableDetailPage } from '../table.detail.page';

@Component({
  selector: 'app-dynamic',
  templateUrl: './dynamic.component.html',
  styleUrls: ['./dynamic.component.css']
})
export class DynamicComponent implements OnInit {
  private _elements: WidgetComponent[] = [];
  @ViewChild('container', {read: ViewContainerRef, static: true}) container: ViewContainerRef;

  constructor(private compFactoryResolver: ComponentFactoryResolver) {
  }

  public createGenericComponent(genericComponent: Type<any>): ComponentRef<WidgetComponent> {
    const factory = this.compFactoryResolver.resolveComponentFactory(genericComponent);

    return this.container.createComponent(factory);
  }

  public createComponent(detailComponent: Type<TableDetailPage>,
    table: TableComponent, element: TableElement, columns: TableColumn[]): ComponentRef<TableDetailPage> {

    const ngItem: Type<TableDetailPage> = detailComponent;
    const factory = this.compFactoryResolver.resolveComponentFactory(ngItem);
    const ref = this.container.createComponent(factory);

    const newItem: TableDetailPage = ref.instance;

    newItem.setContent(table, element, columns);

    return ref;
  }

  public addComponent(cellComponent: Type<WidgetComponent>,
    table: TableComponent, element: TableElement, column: TableColumn): WidgetComponent {

    const ngItem: Type<WidgetComponent> = cellComponent;
    const factory = this.compFactoryResolver.resolveComponentFactory(ngItem);
    const ref = this.container.createComponent(factory);

    const newItem: WidgetComponent = ref.instance;
    this._elements.push(newItem);

    newItem.setContent(table, element, column);

    return newItem;
  }

  resetContainer() {
    this._elements = [];
  }

  ngOnInit() {
  }

}
